import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Maybe } from '../../../../../utils/maybe';
import { AbsenceRequest } from '../types';
import { ApprovalRequest } from '../../../pages/Absences/MyAbsences/MyAbsenceFilters/types';

export const getRelatedApprovalRequest = (
  absence: AbsenceRequest,
): Maybe<ApprovalRequest> => {
  if (!absence.id) return null;

  const relatedRequest = absence.approvalRequests.find(
    (req) => req.relatedId === absence.absenceId,
  );

  if (!relatedRequest) return null;

  return relatedRequest;
};

export const useApprovalRequestSidebar = (requests: AbsenceRequest[]) => {
  const history = useHistory();
  const location = useLocation();
  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const approvalRequestId = query.get('approvalRequestId');
  const absenceId = query.get('absenceId');

  const updateUrlParams = useCallback(
    (approvalRequestId: string | null, absenceId: string | null) => {
      const newQuery = new URLSearchParams(location.search);

      newQuery.delete('approvalRequestId');
      newQuery.delete('absenceId');

      if (approvalRequestId) {
        newQuery.set('approvalRequestId', approvalRequestId);
      } else if (absenceId) {
        newQuery.set('absenceId', absenceId);
      }
      history.push({ search: newQuery.toString() });
    },
    [history, location.search],
  );

  const handleAbsenceClick = useCallback(
    (row: AbsenceRequest) => {
      const relatedRequest = getRelatedApprovalRequest(row);
      if (relatedRequest?.id) {
        updateUrlParams(relatedRequest.id, null);
      } else {
        updateUrlParams(null, row.absenceId);
      }
    },
    [updateUrlParams],
  );

  const handleClose = useCallback(() => {
    updateUrlParams(null, null);
  }, [updateUrlParams]);

  return {
    selectedAbsenceId: absenceId,
    selectedApprovalRequestId: approvalRequestId,
    handleAbsenceClick,
    handleClose,
  };
};
